import React, { useState, useEffect, useContext } from 'react';
import { ContactPersonMultiFieldType, FieldData } from 'types/FieldTypes';
import FormFieldContext from '../FormFieldContext';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from 'GlobalContext';
import FieldWrapper from '../FieldWrapper';
import FieldViewMode from '../fields/elements/FieldViewMode';
import '../../../style/scss/live-edit.scss';
import '../../../style/scss/forms.scss';
import '../../../style/scss/tooltip.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const ContactPersonMultiField: React.FC<ContactPersonMultiFieldType & { data: FieldData, viewKey: string }> = ({ 
    viewKey, name, label, data, helperText, tooltipText, viewInEditMode, alignment, isEditable, disabled
}) => {
    const { t } = useTranslation();
    const { editing, updatedData, setUpdatedData, handleSubmit } = useContext(FormFieldContext);
    const { errorMessages, setUnsavedChanges } = useGlobalContext();
    const [selectedItem, setSelectedItem] = useState<number | null>(null);
    const [title, setTitle] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [fullName, setFullName] = useState<string>('');
        
    // Load the current values inside the fields
    useEffect(() => {
        // console.log(data[name])
        // // Set the internal reference from the data
        // if (data && data[`internal_${name}`]) {
        //     setInternalReference(data[`internal_${name}`]);
        // }

        // // Set the external reference from the data
        // if (data && data[`external_${name}`]) {
        //     setExternalReference(data[`external_${name}`]);
        // }
    }, [data, name]);

    // Handle the input change
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: 'title' | 'first_name' | 'last_name') => {

        // // Set the value
        // if (fieldName == 'internal_reference') setInternalReference(e.target.value);
        // if (fieldName == 'external_reference') setExternalReference(e.target.value);

        // Set updated data
        setUpdatedData((prevData: Record<string, any>) => ({
            ...updatedData,
            ...prevData,
            [fieldName]: e.target.value
        }));

        // Set unsaved changes
        const hasChanges = e.target.value !== data[fieldName];
        setUnsavedChanges(viewKey, hasChanges);
    }

    // Submits the value after pressing enter
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (name && !errorMessages[name]) {
                if (handleSubmit) handleSubmit();
            }
        }
    }

    // Combine both references to show in the view mode
    const combinedReference = () => {
        let combinedReference = '';
        
        // if (internalReference && externalReference) {
        //     combinedReference = `${internalReference} • ${externalReference}`;
        // } else if (internalReference) {
        //     combinedReference = internalReference;
        // } else if (externalReference) {
        //     combinedReference = externalReference;
        // }
    
        return combinedReference;
    }

    return (
        <FieldWrapper
            name={name}
            label={label}
            tooltipText={tooltipText}
            helperText={helperText}
            isEditable={isEditable}
            disabled={disabled}
            viewInEditMode={viewInEditMode}
            alignment={alignment}>
            {(editing || viewInEditMode) ? (
                // Edit mode
                <div className='contact-person-multi-field'>
                    <div className='field-column'>
                        <label htmlFor={name}>
                            {t('person.general.salutation_label')}
                        </label>
                        <input
                            type="text"
                            id='internal_reference'
                            name='internal_reference'
                            placeholder={t('person.general.salutation_label')}
                            value={title}
                            disabled={disabled}
                            onChange={(e) => handleInputChange(e, 'title')}
                            className={`text ${errorMessages[name] ? 'is-invalid' : ''}`}
                            autoFocus={true}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    <div className='field-column'>
                        <label htmlFor={name}>
                            {t('person.general.first_name_label')}
                        </label>
                        <input
                            type="text"
                            id='first_name'
                            name='first_name'
                            placeholder={t('person.general.first_name_label')}
                            value={firstName}
                            disabled={disabled}
                            onChange={(e) => handleInputChange(e, 'first_name')}
                            className={`text ${errorMessages[name] ? 'is-invalid' : ''}`}
                            autoFocus={false}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    <div className='field-column'>
                        <label htmlFor={name}>
                            {t('person.general.last_name_label')}
                        </label>
                        <input
                            type="text"
                            id='last_name'
                            name='last_name'
                            placeholder={t('person.general.last_name_label')}
                            value={firstName}
                            disabled={disabled}
                            onChange={(e) => handleInputChange(e, 'last_name')}
                            className={`text ${errorMessages[name] ? 'is-invalid' : ''}`}
                            autoFocus={false}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                    <div className='field-column'>
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </div>
                </div>
            ) : (
                // View mode
                <FieldViewMode 
                    type="data"
                    value={combinedReference()} 
                    alignment={alignment}
                />
            )}
        </FieldWrapper>
    );
};

export default ContactPersonMultiField;